import { useEffect, useRef } from 'react';

/* ─── EXPÉRIENCES PROFESSIONNELLES ─── */
const experiences = [
  {
    period: '19 Fév 2026 — Présent',
    role: 'Développeur Manager Web & AI',
    company: 'Ls Compétence Casablanca',
    companyUrl: 'https://linkedin.com/company/digital-agency-casablanca',
    logo: '/vignette-qualiopi-marque-de-certification_0.jpg - Copie.webp',
    current: true,
    desc: 'Développeur Manager Web & AI spécialisé dans l’intégration de l’IA. Je pilote actuellement le développement d’une plateforme SaaS dédiée à la certification Qualiopi pour automatiser les processus de conformité et de gestion de la qualité.',
    tasks: [
      'Management technique et direction de l’intégration AI dans les solutions web',
      'Conception et développement d’une plateforme SaaS Qualiopi (pilotage métier)',
      'Développement d’architectures web scalables avec React.js + Node.js',
      'Mise en place d’automatisations intelligentes pour la gestion de la qualité',
      'Mentorat technique et revue de code stratégique pour l\'équipe agile',
    ],
  },
  {
    period: '15 Sept 2025 — 15 Fév 2026',
    role: 'Développeur Web',
    company: 'No Limits Travel DMC',
    companyUrl: '#',
    logo: '/No.jpg',
    desc: 'Conception et développement d’une plateforme web de tourisme innovante. Intégration de solutions IA pour optimiser la planification de voyages et améliorer l’expérience utilisateur.',
    tasks: [
      'Développement d’une architecture web robuste pour le secteur du tourisme',
      'Intégration d’algorithmes IA pour la recommandation personnalisée (itinéraires)',
      'Optimisation de l’interface utilisateur pour une navigation fluide et intuitive',
      'Gestion de bases de données pour les catalogues et réservations voyages',
    ],
  },
  {
    period: 'Jan 2025 — Juil 2025',
    role: 'Développeur Web',
    company: 'Web Solutions Provider',
    companyUrl: '#',
    desc: 'Développement d’applications web sur mesure et intégration de solutions de gestion d’entreprise pour optimiser les flux de travail opérationnels.',
    tasks: [
      'Conception et développement de projets web complexes avec architectures MVC',
      'Mise en place et personnalisation de solutions CRM pour la gestion de la relation client',
      'Développement et intégration de modules ERP pour la gestion des ressources globales',
      'Optimisation des performances backend et sécurisation des API',
    ],
  },
];

/* ─── STAGES ─── */
const stages = [
  {
    period: '05 Mars 2024 — 05 Juil 2024',
    role: 'Stage PFE — Développeur Mobile',
    company: 'MobiArchitects, Casablanca',
    companyUrl: '#',
    logo: '/logo_MobiArchitects.png',
    desc: 'Développement d\'une plateforme mobile pour Electroplanet. Migration technologique majeure pour améliorer la maintenabilité et les performances.',
    tasks: [
      'Redéveloppement complet de l’application Electroplanet avec le langage Flutter',
      'Migration d’une base de code existante de Xamarin vers Flutter',
      'Optimisation de l’expérience utilisateur mobile et des temps de réponse',
      'Intégration d’API REST pour la synchronisation des données en temps réel',
    ],
  },
  {
    period: 'Août 2023 — Octobre 2023',
    role: 'Stage PFA — Développeur Full Stack',
    company: 'JC Web, Marrakech',
    companyUrl: '#',
    logo: '/images.png',
    desc: 'Développement d’une plateforme web de gestion pour un cabinet médical, visant à digitaliser le suivi des patients et la gestion des rendez-vous.',
    tasks: [
      'Conception et développement de la plateforme avec Spring Boot (Java) et React.js',
      'Mise en place d’un système de gestion des dossiers patients et historique médical',
      'Développement d’un module de prise de rendez-vous et gestion des consultations',
      'Optimisation de la base de données pour assurer la sécurité des données médicales',
    ],
  },
  {
    period: '10 Août 2022 — 10 Sept 2022',
    role: 'Stage d\'été — Développeur Mobile (Hybride)',
    company: 'OCP, Casablanca',
    companyUrl: '#',
    logo: '/popp.jpg',
    desc: 'Développement d’une application mobile interne pour la gestion et le suivi des livraisons de produits au sein de la structure OCP.',
    tasks: [
      'Conception et développement d’une interface mobile intuitive pour le suivi des livraisons',
      'Mise en place de fonctionnalités de géolocalisation pour optimiser les trajets de livraison',
      'Intégration d’un système de notification en temps réel pour le statut des produits',
      'Participation à la refonte de l’expérience utilisateur pour la logistique interne',
    ],
  },
];

/* ─── FORMATIONS ─── */
const formations = [
  {
    period: '2021 — 2024',
    role: 'Ingénieur en Informatique — Option MIAGE',
    company: 'EMSI (École Marocaine des Sciences de l\'Ingénieur), Casablanca',
    logo: '/emsi.png',
    desc: 'Formation d\'ingénieur en informatique spécialité Méthodes Informatiques Appliquées à la Gestion des Entreprises (MIAGE). Un parcours intensif mêlant développement logiciel, gestion de projets IT et intelligence artificielle.',
    tasks: [
      'Plus de 14 certifications académiques obtenues (Langages de programmation, Méthodes Agiles)',
      'Certifications délivrées par des institutions prestigieuses : IBM, Google, Harvard University',
      'Projets académiques avancés en développement web, mobile et desktop',
      'Maîtrise des cycles de vie du développement logiciel et gestion de projets IT',
      'Participation active à des hackathons et compétitions de code nationales',
    ],
  },
  {
    period: '2018 — 2021',
    role: 'Diplôme Universitaire — Sciences et Techniques',
    company: 'FST (Faculté des Sciences et Techniques), Béni Mellal',
    companyUrl: '#',
    logo: '/imagesss.png',
    desc: 'Formation universitaire en Sciences et Techniques avec un solide socle en mathématiques, physique et informatique. C\'est durant ce parcours que j\'ai découvert ma passion pour le développement informatique et décidé de poursuivre en ingénierie.',
    tasks: [
      'Formation de base en algorithmique, structures de données et programmation',
      'Modules en mathématiques appliquées et physique',
      'Initiation au développement web et aux bases de données',
      'Décision de poursuivre en cycle d\'ingénieur en informatique',
    ],
  },
  {
    period: '2017 — 2018',
    role: 'Double Baccalauréat',
    company: 'Lycée, Maroc',
    companyUrl: '#',
    desc: 'Obtention de deux baccalauréats : Sciences Mathématiques (2017) et Bac Libre en Sciences Physiques (2018), témoignant d\'une forte motivation et d\'une capacité à relever des défis académiques.',
    tasks: [
      'Baccalauréat Sciences Mathématiques — 2017',
      'Baccalauréat Libre Sciences Physiques — 2018',
    ],
  },
];

export default function Experience() {
  const refs = useRef([]);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          e.target.classList.add('timeline-item');
        }
      }),
      { threshold: 0.15 }
    );
    refs.current.forEach(r => r && obs.observe(r));
    return () => obs.disconnect();
  }, []);

  let refIdx = 0;

  return (
    <section id="experience">
      <div className="container">

        {/* ═══ EXPÉRIENCES PROFESSIONNELLES ═══ */}
        <p className="section-label reveal" ref={el => refs.current[refIdx++] = el}>Parcours</p>
        <h2 className="section-title reveal" ref={el => refs.current[refIdx++] = el} style={{ transitionDelay: '0.1s' }}>
          Expérience <em>professionnelle</em>
        </h2>

        <div className="timeline">
          {experiences.map((exp, i) => {
            const idx = refIdx++;
            return (
              <div
                key={i}
                className="timeline-item reveal"
                ref={el => refs.current[idx] = el}
                style={{ transitionDelay: `${0.15 * i}s` }}
              >
                <div className="exp-period">{exp.period}</div>
                <h3 className="exp-role">{exp.role}</h3>
                <div className="exp-company">
                  <a href={exp.companyUrl} target="_blank" rel="noreferrer">
                    {exp.company}
                  </a>
                  {exp.logo && (
                    <img
                      src={exp.logo}
                      alt="Logo certification"
                      className="exp-logo"
                    />
                  )}
                  {exp.current && <span className="current-badge">Actuel</span>}
                </div>
                <p className="exp-desc">{exp.desc}</p>
                <h4 className="exp-tasks-title">Les Compétences</h4>
                <ul className="exp-tasks">
                  {exp.tasks.map((t, j) => (
                    <li key={j}>{t}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        {/* ═══ STAGES ═══ */}
        <h2 className="section-title reveal" ref={el => refs.current[refIdx++] = el} style={{ marginTop: 80, transitionDelay: '0.1s' }}>
          Stages <em>& immersions</em>
        </h2>

        <div className="timeline">
          {stages.map((exp, i) => {
            const idx = refIdx++;
            return (
              <div
                key={i}
                className="timeline-item reveal"
                ref={el => refs.current[idx] = el}
                style={{ transitionDelay: `${0.15 * i}s` }}
              >
                <div className="exp-period">{exp.period}</div>
                <h3 className="exp-role">{exp.role}</h3>
                <div className="exp-company">
                  <a href={exp.companyUrl} target="_blank" rel="noreferrer">
                    {exp.company}
                  </a>
                  {exp.logo && (
                    <img
                      src={exp.logo}
                      alt="Logo stage"
                      className="exp-logo"
                    />
                  )}
                </div>
                <p className="exp-desc">{exp.desc}</p>
                <h4 className="exp-tasks-title">Les Compétences</h4>
                <ul className="exp-tasks">
                  {exp.tasks.map((t, j) => (
                    <li key={j}>{t}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        {/* ═══ FORMATIONS ═══ */}
        <h2 className="section-title reveal" ref={el => refs.current[refIdx++] = el} style={{ marginTop: 80, transitionDelay: '0.1s' }}>
          Formation <em>& diplômes</em>
        </h2>

        <div className="timeline">
          {formations.map((exp, i) => {
            const idx = refIdx++;
            return (
              <div
                key={i}
                className="timeline-item reveal"
                ref={el => refs.current[idx] = el}
                style={{ transitionDelay: `${0.15 * i}s` }}
              >
                <div className="exp-period">{exp.period}</div>
                <h3 className="exp-role">{exp.role}</h3>
                <div className="exp-company">
                  <a href={exp.companyUrl} target="_blank" rel="noreferrer">
                    {exp.company}
                  </a>
                  {exp.logo && (
                    <img
                      src={exp.logo}
                      alt="Logo formation"
                      className="exp-logo"
                    />
                  )}
                </div>
                <p className="exp-desc">{exp.desc}</p>
                <h4 className="exp-tasks-title">Les Compétences</h4>
                <ul className="exp-tasks">
                  {exp.tasks.map((t, j) => (
                    <li key={j}>{t}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
